/* import __COLOCATED_TEMPLATE__ from './fin-sops-editor-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import templateOnlyComponent from '@ember/component/template-only';
import type FinSopsEditorPayload from 'embercom/components/workflows/graph-editor/node-items/steps/fin-custom';

interface Signature {
  Args: {
    model: {
      open?: boolean;
      onClose: () => void;
      finSopsEditorPayload: FinSopsEditorPayload;
    };
  };
}

const FinSopsEditorSheet = templateOnlyComponent<Signature>();
export default FinSopsEditorSheet;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::Workflows::FinSopsEditorSheet': typeof FinSopsEditorSheet;
    'react/workflows/fin-sops-editor-sheet': typeof FinSopsEditorSheet;
  }
}
